import { useRouteShellContext } from "@components/routeShellContext"
import type { SupportedLocale as Lang } from "@site-types/content"
import { createContext, useContext } from "react"

export const SendMailLangContext = createContext<Lang | undefined>(undefined)

export function useSendMailLang() {
  const providedLang = useContext(SendMailLangContext)
  const { locale } = useRouteShellContext()

  return providedLang ?? locale
}
